<p-blockUI [blocked]="blocked">
	<div id="center">
		<p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
	</div>
</p-blockUI>

<p-panel header="{{protocolStepName}}" [toggleable]="true">
	<div class="mt-1 mx-1 grid justify-content-between h-full">
		<div class="col-7">
			<div name="batch-id" class="p-inputgroup my-2">
				<button pButton class="w-5 h-2rem md:text-sm px-0" type="button" label="Batch-ID"></button>
				<input id="batch-id" [disabled]="true" class="text-sm lg:w-7 md:w-7 sm:w-full py-0" [(ngModel)]="batchId" />
			</div>
			<div name="sample-barcode" class="p-inputgroup my-2">
				<button pButton class="w-5 h-2rem md:text-sm px-0" type="button" [label]="getNextSampleCountInBatch()"></button>
				<input id="sample-barcode-scan-field" [disabled]="disableScanBarcodeField()" class="text-sm w-7 py-0" [(ngModel)]="scannedSampleBarcode" (keydown.enter)="searchAndAddSampleToBatch(scannedSampleBarcode)" />
			</div>
		</div>
		<div class="col-3">
			<button pButton class="my-2 w-full action-button h-2rem md:text-sm text-primary px-0" type="button" label="New" (click)="createNewBatch()"></button>
		</div>
	</div>
	<div>
		<div class="p-2">
			<p-table [value]="batchSamples" styleClass="p-datatable-striped mx-1 md:text-sm lg:text-md" [scrollable]="true" scrollHeight="25vh">
				<ng-template pTemplate="header">
					<tr>
						<th scope="col" class="table-cell w-3">Position</th>
						<th scope="col" class="table-cell">Sample</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-sample let-rowIndex="rowIndex">
					<tr>
						<td class="table-cell w-3">{{ batch.samples.length - rowIndex }}</td>
						<td class="table-cell">{{ sample.sampleID }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-panel>

<p-dialog [(visible)]="showDuplicateSampleSelectionDialog" header="Select Sample" class="bg-primary button-dialog" styleClass="w-8 min-w-min"
	position="top" [modal]="true" [baseZIndex]="1000">
	<app-duplicate-sample-selection [duplicateSamples]="samplesWithSameBarcode" (sampleSelectionEmitter)="selectedSampleFromDuplicate($event)"></app-duplicate-sample-selection>
</p-dialog>